import styled from 'styled-components';

import { breakpoint } from '@ovpn/ui/tokens';

import { Box } from '@sso/shared/core';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 904px;

    @media (max-width: ${breakpoint.md - 1}px) {
        max-width: 512px;
    }
`;

export const Cards = styled.div`
    display: flex;
    gap: 24px;

    @media (max-width: ${breakpoint.md - 1}px) {
        flex-direction: column;
        align-items: center;
    }
`;
